var render, staticRenderFns
import script from "./business_ownership_one.vue?vue&type=script&lang=js"
export * from "./business_ownership_one.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dc90ada')) {
      api.createRecord('3dc90ada', component.options)
    } else {
      api.reload('3dc90ada', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/customer_org/associated/business_ownership/business_ownership_one.vue"
export default component.exports